export const GET_ITEM_MBQ_MOQ = "GET_ITEM_MBQ_MOQ";
export const GET_ITEM_MBQ_MOQ_SUCCESS = "GET_ITEM_MBQ_MOQ_SUCCESS";

export const SAVE_ITEM_MBQ_MOQ = "SAVE_ITEM_MBQ_MOQ";
export const SAVE_ITEM_MBQ_MOQ_SUCCESS = "SAVE_ITEM_MBQ_MOQ_SUCCESS";

export const DELETE_ITEM_MBQ_MOQ = "DELETE_ITEM_MBQ_MOQ";
export const DELETE_ITEM_MBQ_MOQ_SUCCESS = "DELETE_ITEM_MBQ_MOQ_SUCCESS";

export const ITEM_MBQ_MOQ_ERROR = "ITEM_MBQ_MOQ_ERROR";
export const RESET_ITEM_MBQ_MOQ_STATE = "RESET_ITEM_MBQ_MOQ_STATE";